<template>
  <div class="app-content">
    <transition name="fade" mode="out-in">
      <div v-if="loadingContent" class="w3-center">
        <spinner-loading :size="32" />
      </div>
      <div v-else class="content-response" v-html="contentResponse"></div>
    </transition>
  </div>
</template>

<script>
import * as appTypes from '@/store/actions/app'
import * as authTypes from '@/store/actions/auth'
import * as api from '@/utils/api'

export default {
  name: 'appContent',
  data () {
    return {
      currentContent: {},
      loadingContent: false,
      contentResponse: ''
    }
  },
  beforeMount () {
    this.currentContent = this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`]
    this.getContent()
  },
  computed: {
    newCurrentContent () {
      return this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_CONTENT}`]
    }
  },
  watch: {
    newCurrentContent (newCurrentContent) {
      this.currentContent = newCurrentContent
    }
  },
  methods: {
    getContent () {
      this.loadingContent = true
      api.call({access: api.ACCESS_SERVICES, url: this.currentContent.type.endpoint, method: 'POST', data: { }})
        .then(resp => {
          this.contentResponse = resp
          this.loadingContent = false
        })
        .catch(err => {
          this.loadingContent = false
          // open error service dialog
          this.$store.dispatch(`${authTypes.AUTH_NAMESPACE}/${authTypes.AUTH_STATUS_ERROR}`, err)
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  /* css per home */
  .w3-container.home-container {
    height: 100%;

    .home-kpi {
      min-height: 400px;
      margin-bottom: 50px;

      .kpi-title {
        width: 100%;
        min-height: 40px;
        background-color: #e4e4e4;
        padding-left: 15px;
        text-align: left;
      }
    }
  }
  .nvd3-svg {
    width: 90%;
    min-height: 400px;
    margin-left: 10px;
    overflow: initial;
  }
</style>
